"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.99 6.99H4.41L7.7 3.7a1.003 1.003 0 00-1.42-1.42l-5 5a1.014 1.014 0 000 1.42l5 5a1.003 1.003 0 001.42-1.42L4.41 8.99H14c.55 0 1-.45 1-1s-.46-1-1.01-1z"];
//# sourceMappingURL=arrow-left.js.map